﻿angular.module("warsApp.factories").factory('$exceptionHandler', ['$log', function ($log) {

    return function (exception, cause) {
        try {
            var logContext = { stack: exception.stack, cause: cause };
            warsApp.services.WarsLogger.logError(exception.message + "\n\n" + exception.stack, "$exceptionHandler", logContext);
            $log.error(exception, cause)
        }
        catch (loggingError) {
            // For Developers - log the log-failure.
            $log.warn("Error logging failed");
            $log.log(loggingError);
        }
    };
}]);

// Now catch anything outside of the angular pipeline
window.onerror = function (message, url, lineNumber) {
    try {
        var logContext = {
            url: url,
            lineNumber: lineNumber
        };
        warsApp.services.WarsLogger.logError(message, "window.onerror", logContext);
    } catch (ex) {
        return false;
    }
    return true;
};  